import Api from '@/api/api.js'

export default {
    /**
     * Route pour recuperer les bons commandes
     */
    sorties() {
        const promise = Api().get("/sorties");
        return promise.then((response) => response.data);
    },

    getDestockageListe(data) {
        const promise = Api().post("/destockages/liste", data);
        return promise.then((response) => response.data);
    },
    
    getDestockageListes() {
        const promise = Api().get("/destockages/listes");
        return promise.then((response) => response.data);
    },

    /**
     * Enregistrer une sortie
     * @param object data
     */
    saveSortie(data) {
        const promise = Api().post("/sortie", data);
        return promise.then((response) => response.data);
    },

    /**
     *  Recuperer bon commande
     *  @param int id
     */
    getSortie(id) {
        const promise = Api().post("/sortie/" + id);
        return promise.then((response) => response.data);
    },
};